import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { MethodFieldPayloadType } from "@/common/types/method/method-field";

export async function methodFieldList(
  account_id: string,
  group_id: string,
  query?: QueryType,
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/method/${group_id}/field/list${queryString}`,
  );
}

export async function methodFieldShow(account_id: string, field_id: string) {
  return await clientAxios.get(
    `account/${account_id}/method/field/${field_id}/show`,
  );
}

export async function methodFieldCreate(
  account_id: string,
  group_id: string,
  payload: MethodFieldPayloadType,
) {
  return await clientAxios.post(
    `account/${account_id}/method/${group_id}/field/create`,
    payload,
  );
}

export async function methodFieldUpdate(
  account_id: string,
  field_id: string,
  payload: MethodFieldPayloadType,
) {
  return await clientAxios.put(
    `account/${account_id}/method/field/${field_id}/update`,
    payload,
  );
}

export async function methodFieldDelete(account_id: string, field_id: string) {
  return await clientAxios.del(
    `account/${account_id}/method/field/${field_id}/delete`,
  );
}
